<div class="divine-service-header">
  <div class="header-content">
    <div class="header-top">
      <button mat-icon-button (click)="back.emit()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="title-block">
        <div class="title-line">
          <span class="service-date service-date--desktop">{{ formatDate(service.startAt) }}</span>
          <span class="service-date service-date--mobile">{{ formatMobileDate(service.startAt) }}</span>
          <span
            class="attendance-status attendance-status--header"
            [class.attendance-status--closed]="service.isClosed">
            <mat-icon>{{ service.isClosed ? 'lock' : 'lock_open' }}</mat-icon>
            {{ service.isClosed ? 'Cerrado' : 'Abierto' }}
          </span>
          <span class="bible-text" *ngIf="service.bibleText">{{ service.bibleText }}</span>
        </div>
        <div class="subtitle-line">
          <a
            *ngIf="service.organizationUnitName"
            [routerLink]="['/units', service.organizationUnitId]"
            class="unit-link">
            {{ service.organizationUnitName }}
          </a>
          <span *ngIf="service.organizationUnitName && service.typeName" class="separator"> - </span>
          <span *ngIf="service.typeName">{{ service.typeName }}</span>
        </div>
      </div>
    </div>

    <div class="header-actions">
      <div class="attendance-summary attendance-summary--desktop">
        <div class="attendance-totals">
          <button mat-icon-button type="button" matTooltip="Detalle" aria-label="Detalle de concurrencia"
            (click)="attendanceDetail.emit()">
            <mat-icon>unfold_more</mat-icon>
          </button>
          <div class="stats-box" aria-label="Resumen de concurrencia">
            <div class="stat-cell adults">
              <span class="stat-label">MAY</span>
              <span class="stat-value">{{ totalAdults }}</span>
            </div>
            <div class="stat-cell minors">
              <span class="stat-label">MEN</span>
              <span class="stat-value">{{ totalMinors }}</span>
            </div>
            <div class="stat-cell total">
              <span class="stat-label">TOT</span>
              <span class="stat-value">{{ attendanceTotal }}</span>
            </div>
          </div>
        </div>
        <div class="attendance-close">
          <button
            *ngIf="!service.isClosed && (canManageDivineServices$ | async)"
            mat-flat-button
            type="button"
            class="close-attendance-button"
            matTooltip="Cerrar concurrencia"
            (click)="closeAttendance.emit()">
            <mat-icon>lock_outline</mat-icon>
            <span>Cerrar</span>
          </button>
        </div>
      </div>

      <button *ngIf="canManageDivineServices$ | async" mat-icon-button [matMenuTriggerFor]="menu" class="menu-button">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="edit.emit()">
        <mat-icon>edit</mat-icon>
        <span>Editar Servicio Divino</span>
      </button>
      <button mat-menu-item class="danger-menu-item" (click)="delete.emit()">
        <mat-icon>delete</mat-icon>
        <span>Eliminar Servicio Divino</span>
      </button>
    </mat-menu>

    <div class="attendance-summary attendance-summary--mobile">
      <div class="attendance-totals">
        <button mat-icon-button type="button" matTooltip="Detalle" aria-label="Detalle de concurrencia"
          (click)="attendanceDetail.emit()">
          <mat-icon>unfold_more</mat-icon>
        </button>
        <div class="stats-box" aria-label="Resumen de concurrencia">
          <div class="stat-cell adults">
            <span class="stat-label">MAY</span>
            <span class="stat-value">{{ totalAdults }}</span>
          </div>
          <div class="stat-cell minors">
            <span class="stat-label">MEN</span>
            <span class="stat-value">{{ totalMinors }}</span>
          </div>
          <div class="stat-cell total">
            <span class="stat-label">TOT</span>
            <span class="stat-value">{{ attendanceTotal }}</span>
          </div>
        </div>
      </div>
      <div class="attendance-close">
        <span class="attendance-status attendance-status--mobile-action" [class.attendance-status--closed]="service.isClosed">
          <mat-icon>{{ service.isClosed ? 'lock' : 'lock_open' }}</mat-icon>
          {{ service.isClosed ? 'Cerrado' : 'Abierto' }}
        </span>
        <button
          *ngIf="!service.isClosed && (canManageDivineServices$ | async)"
          mat-flat-button
          type="button"
          class="close-attendance-button"
          matTooltip="Cerrar concurrencia"
          (click)="closeAttendance.emit()">
          <mat-icon>lock_outline</mat-icon>
          <span>Cerrar</span>
        </button>
      </div>
    </div>
  </div>
</div>
